import {
  ArrowRight,
  MapPin,
  Users,
  Star,
  Globe,
  ArrowDown,
  CheckCircle,
  XCircle,
  Briefcase,
  DollarSign,
  MessageSquare,
  Shield,
  BarChart,
  Map,
  Compass,
  Heart,
  UserPlus,
} from "lucide-react";
import { isMobile } from "react-device-detect";

const SotravelXInfo = () => {
  return (
    <div className="tw-min-h-screen tw-font-sans">
      {/* Hero Section with Parallax Effect */}
      <section className="tw-relative tw-h-[70vh] tw-overflow-hidden">
        <div
          className="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-transform tw-scale-110"
          style={{
            backgroundImage:
              "url('https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/151028Copy%20of%20IMG_4012.JPG')",
            transform: "translateZ(-1px) scale(1)",
          }}
        />
        <div className="tw-absolute tw-inset-0 tw-bg-black/50" />
        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
          <div className="tw-text-center tw-text-white tw-max-w-4xl tw-px-4">
            <h1 className="tw-text-[34px] md:tw-text-[52px] tw-font-bold tw-mb-3 tw-leading-tight">
              Take your travel passion to the next level
            </h1>
            <p className="tw-text-[18px] md:tw-text-[20px] tw-mb-5 tw-text-gray-200 tw-max-w-2xl tw-mx-auto">
              Create and sell unique group trips with Sotravel X
            </p>
            <button
              onClick={() =>
                window.open("https://t.me/m/WhitDFiSOGY1", "_blank")
              }
              className="tw-bg-[#00BFFF] tw-text-white tw-font-medium tw-py-2.5 tw-px-6 tw-rounded-full tw-text-[16px] hover:tw-bg-[#00A3D9] tw-transition tw-duration-300"
            >
              Chat with us
            </button>
          </div>
        </div>
      </section>

      {/* Why Host a Trip Section */}
      <section className="tw-py-12 tw-bg-white">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-text-[26px] tw-font-bold tw-text-center tw-mb-8">
            Why Host a Trip with Sotravel X?
          </h2>
          <p className="tw-text-[18px] tw-text-gray-600 tw-text-center tw-mb-8 tw-max-w-3xl tw-mx-auto">
            Sotravel X empowers individuals to design and sell their own group
            travel experiences—without the hassle of logistics, customer
            service, or payment processing.
          </p>
          <div className="tw-grid md:tw-grid-cols-3 tw-gap-6 tw-max-w-5xl tw-mx-auto">
            <div className="tw-bg-white tw-rounded-lg tw-p-6 tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-w-12 tw-h-12 tw-bg-[#00BFFF] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                  <DollarSign className="tw-text-white tw-w-6 tw-h-6" />
                </div>
                <div>
                  <h3 className="tw-text-[20px] tw-font-medium tw-mb-2">
                    Earn from your expertise
                  </h3>
                  <p className="tw-text-[16px] tw-text-gray-600">
                    Create trips tailored to your niche and monetize your travel
                    knowledge and audience.
                  </p>
                </div>
              </div>
            </div>
            <div className="tw-bg-white tw-rounded-lg tw-p-6 tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-w-12 tw-h-12 tw-bg-[#00BFFF] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                  <Users className="tw-text-white tw-w-6 tw-h-6" />
                </div>
                <div>
                  <h3 className="tw-text-[20px] tw-font-medium tw-mb-2">
                    Sell out faster
                  </h3>
                  <p className="tw-text-[16px] tw-text-gray-600">
                    Access built-in marketing tools and an engaged traveler
                    community to fill your trips quickly.
                  </p>
                </div>
              </div>
            </div>
            <div className="tw-bg-white tw-rounded-lg tw-p-6 tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-w-12 tw-h-12 tw-bg-[#00BFFF] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                  <Compass className="tw-text-white tw-w-6 tw-h-6" />
                </div>
                <div>
                  <h3 className="tw-text-[20px] tw-font-medium tw-mb-2">
                    Focus on experiences
                  </h3>
                  <p className="tw-text-[16px] tw-text-gray-600">
                    We handle customer management, payments, and coordination so
                    you can focus on creating amazing trips.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who Can Become a Trip Creator Section */}
      <section className="tw-py-12 tw-bg-gray-50">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-text-[26px] tw-font-bold tw-text-center tw-mb-8">
            Who can become a trip creator?
          </h2>
          <p className="tw-text-[18px] tw-text-gray-600 tw-text-center tw-mb-8 tw-max-w-3xl tw-mx-auto">
            Sotravel X is built for passionate individuals who want to share
            their travel expertise
          </p>
          <div className="tw-grid md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4 tw-max-w-5xl tw-mx-auto">
            <div className="tw-bg-white tw-p-5 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF]/10 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                  <Star className="tw-text-[#00BFFF] tw-w-5 tw-h-5" />
                </div>
                <h3 className="tw-text-[18px] tw-font-medium">
                  Content creators & influencers
                </h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Who want to travel with their audience and create deeper
                connections
              </p>
            </div>
            <div className="tw-bg-white tw-p-5 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF]/10 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                  <Map className="tw-text-[#00BFFF] tw-w-5 tw-h-5" />
                </div>
                <h3 className="tw-text-[18px] tw-font-medium">
                  Travel enthusiasts & experts
                </h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Looking to share their favorite destinations and insider
                knowledge
              </p>
            </div>
            <div className="tw-bg-white tw-p-5 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF]/10 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                  <Users className="tw-text-[#00BFFF] tw-w-5 tw-h-5" />
                </div>
                <h3 className="tw-text-[18px] tw-font-medium">
                  Community leaders
                </h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Who already bring people together and want to expand to travel
                experiences
              </p>
            </div>
            <div className="tw-bg-white tw-p-5 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-center tw-gap-3 tw-mb-3">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF]/10 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                  <Briefcase className="tw-text-[#00BFFF] tw-w-5 tw-h-5" />
                </div>
                <h3 className="tw-text-[18px] tw-font-medium">
                  Aspiring travel entrepreneurs
                </h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Who want to run trips without the upfront costs and operational
                headaches
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="tw-py-12 tw-bg-white">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-text-[26px] tw-font-bold tw-text-center tw-mb-8">
            How It Works
          </h2>
          <div className="tw-relative tw-max-w-4xl tw-mx-auto">
            <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-h-full tw-w-1 tw-bg-[#00BFFF] tw-z-10">
              <div className="tw-absolute -tw-top-2 tw-left-1/2 -tw-translate-x-1/2 tw-w-4 tw-h-4 tw-rounded-full tw-bg-[#00BFFF]"></div>
              <div className="tw-absolute -tw-bottom-2 tw-left-1/2 -tw-translate-x-1/2 tw-w-4 tw-h-4 tw-rounded-full tw-bg-[#00BFFF]"></div>
            </div>
            <div className="tw-space-y-6 md:tw-space-y-8">
              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                {!isMobile && (
                  <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-z-10">
                    <ArrowDown className="tw-w-8 tw-h-8 tw-text-[#00BFFF] tw-font-bold" />
                  </div>
                )}
                <div className="tw-pl-[calc(3%+2rem)] md:tw-pl-[calc(25%+2rem)] md:tw-w-[700px]">
                  <div className="tw-bg-white/90 tw-backdrop-blur tw-p-6 tw-rounded-xl tw-shadow-md">
                    <h3 className="tw-text-[22px] tw-font-semibold tw-text-[#00BFFF] tw-mb-2">
                      1. Apply & submit your trip concept
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Share your trip idea, target audience, and what makes your
                      experience unique. Our team will review your application
                      and get back to you quickly.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-z-10">
                  <ArrowDown className="tw-w-8 tw-h-8 tw-text-[#00BFFF] tw-font-bold" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-pl-[calc(25%+2rem)] md:tw-w-[700px]">
                  <div className="tw-bg-white/90 tw-backdrop-blur tw-p-6 tw-rounded-xl tw-shadow-md">
                    <h3 className="tw-text-[22px] tw-font-semibold tw-text-[#00BFFF] tw-mb-2">
                      2. Work with our team on trip details
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Collaborate with our travel experts to finalize itinerary,
                      pricing, inclusions, and marketing strategy to ensure your
                      trip stands out.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-z-10">
                  <ArrowDown className="tw-w-8 tw-h-8 tw-text-[#00BFFF] tw-font-bold" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-pl-[calc(25%+2rem)] md:tw-w-[700px]">
                  <div className="tw-bg-white/90 tw-backdrop-blur tw-p-6 tw-rounded-xl tw-shadow-md">
                    <h3 className="tw-text-[22px] tw-font-semibold tw-text-[#00BFFF] tw-mb-2">
                      3. List your trip & start collecting bookings
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Your trip goes live on our platform. Promote it to your
                      audience while we also market it to our community of
                      travelers.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-z-10">
                  <ArrowDown className="tw-w-8 tw-h-8 tw-text-[#00BFFF] tw-font-bold" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-pl-[calc(25%+2rem)] md:tw-w-[700px]">
                  <div className="tw-bg-white/90 tw-backdrop-blur tw-p-6 tw-rounded-xl tw-shadow-md">
                    <h3 className="tw-text-[22px] tw-font-semibold tw-text-[#00BFFF] tw-mb-2">
                      4. We handle the logistics
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Sotravel X takes care of customer sign-ups, payments, and
                      coordination with suppliers so you don't have to worry
                      about the details.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-z-10">
                  <ArrowDown className="tw-w-8 tw-h-8 tw-text-[#00BFFF] tw-font-bold" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-pl-[calc(25%+2rem)] md:tw-w-[700px]">
                  <div className="tw-bg-white/90 tw-backdrop-blur tw-p-6 tw-rounded-xl tw-shadow-md">
                    <h3 className="tw-text-[22px] tw-font-semibold tw-text-[#00BFFF] tw-mb-2">
                      5. Lead an unforgettable experience
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600">
                      Focus on creating amazing memories with your travelers—or
                      build a team to run the trip for you while you scale to
                      multiple destinations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tw-py-16 tw-bg-gray-50">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-text-3xl md:tw-text-4xl tw-font-bold tw-text-center tw-mb-12">
            Why choose Sotravel X over doing it alone?
          </h2>

          <div className="tw-max-w-5xl tw-mx-auto tw-bg-white tw-rounded-xl tw-shadow-md tw-overflow-hidden">
            <div className="tw-grid md:tw-grid-cols-2">
              {/* Header */}
              <div className="tw-bg-gray-100 tw-p-4 tw-font-semibold tw-text-center tw-border-b tw-border-gray-200">
                Without Sotravel X
              </div>
              <div className="tw-bg-[#00BFFF]/10 tw-p-4 tw-font-semibold tw-text-center tw-border-b tw-border-gray-200">
                With Sotravel X
              </div>

              {/* Row 1 */}
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center">
                <XCircle
                  className="tw-text-red-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>Handling customer inquiries</span>
              </div>
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center tw-bg-[#00BFFF]/5">
                <CheckCircle
                  className="tw-text-green-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>We manage customer communication</span>
              </div>

              {/* Row 2 */}
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center">
                <XCircle
                  className="tw-text-red-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>Dealing with payment collection & refunds</span>
              </div>
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center tw-bg-[#00BFFF]/5">
                <CheckCircle
                  className="tw-text-green-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>We process payments & handle refunds</span>
              </div>

              {/* Row 3 */}
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center">
                <XCircle
                  className="tw-text-red-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>Coordinating logistics with local guides</span>
              </div>
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center tw-bg-[#00BFFF]/5">
                <CheckCircle
                  className="tw-text-green-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>We help to coordinate with the local guides</span>
              </div>

              {/* Row 4 */}
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center">
                <XCircle
                  className="tw-text-red-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>Struggling to sell out your trip</span>
              </div>
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center tw-bg-[#00BFFF]/5">
                <CheckCircle
                  className="tw-text-green-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>Get access to a traveler audience & marketing tools</span>
              </div>

              {/* Row 5 */}
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center">
                <XCircle
                  className="tw-text-red-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>Managing bookings manually</span>
              </div>
              <div className="tw-p-4 tw-border-b tw-border-gray-200 tw-flex tw-items-center tw-bg-[#00BFFF]/5">
                <CheckCircle
                  className="tw-text-green-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>Centralized booking & trip management dashboard</span>
              </div>

              {/* Row 6 */}
              <div className="tw-p-4 tw-flex tw-items-center">
                <XCircle
                  className="tw-text-red-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>No support in case of issues</span>
              </div>
              <div className="tw-p-4 tw-flex tw-items-center tw-bg-[#00BFFF]/5">
                <CheckCircle
                  className="tw-text-green-500 tw-mr-3 tw-flex-shrink-0"
                  size={20}
                />
                <span>Dedicated team for assistance</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tw-py-16 tw-bg-[#00BFFF]/5">
        <div className="tw-container tw-mx-auto tw-px-4 tw-text-center">
          <h2 className="tw-text-3xl md:tw-text-4xl tw-font-bold tw-mb-6">
            Ready to launch your first trip?
          </h2>
          <p className="tw-text-xl tw-text-gray-600 tw-mb-10 tw-max-w-2xl tw-mx-auto">
            Apply now and start building your first trip with Sotravel X.
          </p>
          <button
            onClick={() => window.open("https://t.me/m/WhitDFiSOGY1", "_blank")}
            className="tw-bg-[#00BFFF] hover:tw-bg-[#00BFFF]/90 tw-text-white tw-font-medium tw-py-3 tw-px-8 tw-rounded-full tw-text-lg tw-shadow-md hover:tw-shadow-lg tw-transition-all tw-duration-300"
          >
            Apply here
          </button>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="tw-py-16 tw-bg-white">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-text-3xl md:tw-text-4xl tw-font-bold tw-text-center tw-mb-12">
            Frequently asked questions
          </h2>

          <div className="tw-max-w-4xl tw-mx-auto tw-space-y-6">
            <div className="tw-bg-gray-50 tw-rounded-lg tw-p-6 tw-shadow-sm">
              <h3 className="tw-text-xl tw-font-semibold tw-mb-3">
                Who can become a Sotravel X trip creator?
              </h3>
              <p className="tw-text-gray-600">
                This program is ideal for content creators, local experts,
                community leaders, or travel enthusiasts with a specific niche
                or audience!
              </p>
            </div>

            <div className="tw-bg-gray-50 tw-rounded-lg tw-p-6 tw-shadow-sm">
              <h3 className="tw-text-xl tw-font-semibold tw-mb-3">
                Do I need to have travel industry experience?
              </h3>
              <p className="tw-text-gray-600">
                No prior industry experience is required. Our platform is
                designed to handle the technical aspects while you focus on
                creating amazing experiences. We provide training and support
                throughout the process.
              </p>
            </div>

            <div className="tw-bg-gray-50 tw-rounded-lg tw-p-6 tw-shadow-sm">
              <h3 className="tw-text-xl tw-font-semibold tw-mb-3">
                How much does it cost to use Sotravel X?
              </h3>
              <p className="tw-text-gray-600">
                There's no upfront cost to join. We operate on a revenue-share
                model, taking a percentage of bookings. This means we only make
                money when you do, aligning our interests with your success.
              </p>
            </div>

            <div className="tw-bg-gray-50 tw-rounded-lg tw-p-6 tw-shadow-sm">
              <h3 className="tw-text-xl tw-font-semibold tw-mb-3">
                How does the application process work?
              </h3>
              <p className="tw-text-gray-600">
                It typically takes around 2 weeks for us to go from idea to a
                live trip! To start, simply chat with us on Telegram where we
                can get to know each other and share more about the process!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="tw-py-20 tw-bg-gradient-to-r tw-from-[#00BFFF] tw-to-[#0077B6] tw-text-white">
        <div className="tw-container tw-mx-auto tw-px-4 tw-text-center">
          <h2 className="tw-text-3xl md:tw-text-4xl tw-font-bold tw-mb-6">
            Take your travel passion to the next level
          </h2>
          <p className="tw-text-xl tw-mb-10 tw-max-w-2xl tw-mx-auto tw-opacity-90">
            Join Sotravel X today and start creating unforgettable travel
            experiences.
          </p>
          <button
            onClick={() => window.open("https://t.me/m/WhitDFiSOGY1", "_blank")}
            className="tw-bg-white tw-text-[#00BFFF] hover:tw-bg-gray-100 tw-font-bold tw-py-3 tw-px-8 tw-rounded-full tw-text-lg tw-shadow-md hover:tw-shadow-lg tw-transition-all tw-duration-300"
          >
            Chat with us <ArrowRight className="tw-inline tw-ml-2" size={20} />
          </button>
        </div>
      </section>
    </div>
  );
};

export default SotravelXInfo;
